import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HttpModule} from '@angular/http';
import { FormsModule } from '@angular/forms';

import { AccountService } from './services/account.service';
import { AuthService } from './services/auth.service';
import { CategoryService } from './services/category.service';
import { RecurrentService } from './services/recurrent.service';
import { SpinnerService } from './services/spinner.service';
import { StmtService } from './services/stmt.service';
import { TransferService } from './services/transfer.service';

import { AuthGuard } from './guards/auth.guard';
import { InitGuard } from './guards/init.guard';

import { AppComponent } from './app.component';
import { LoginComponent } from './components/login/login.component';
import { HomeComponent } from './components/home/home.component';
import { NavigationComponent } from './components/common/navigation/navigation.component';
import { OverviewComponent } from './components/overview/overview.component';
import { StatementComponent } from './components/statement/statement.component';
import { StatementListComponent } from './components/statement/statement-list/statement-list.component';
import { StatementViewComponent } from './components/statement/statement-view/statement-view.component';
import { TransferComponent } from './components/transfer/transfer.component';
import { TransferEditComponent } from './components/transfer/transfer-edit/transfer-edit.component';
import { RecurrentComponent } from './components/recurrent/recurrent.component';
import { RecurrentListComponent } from './components/recurrent/recurrent-list/recurrent-list.component';
import { RecurrentViewComponent } from './components/recurrent/recurrent-view/recurrent-view.component';
import { CategoryComponent } from './components/category/category.component';
import { CategoryListComponent } from './components/category/category-list/category-list.component';
import { InitComponent } from './components/init/init.component';
import { SigninComponent } from './components/signin/signin.component';
import { ChangeMailComponent } from './components/change-mail/change-mail.component';
import { ForgotPasswordComponent } from './components/forgot-password/forgot-password.component';

import { appRoutes } from './app.routes';

@NgModule({
    declarations: [
        AppComponent,
        HomeComponent,
        NavigationComponent,
        OverviewComponent,
        LoginComponent,
        StatementComponent,
        StatementListComponent,
        StatementViewComponent,
        TransferComponent,
        TransferEditComponent,
        RecurrentComponent,
        RecurrentListComponent,
        RecurrentViewComponent,
        CategoryComponent,
        CategoryListComponent,
        InitComponent,
        SigninComponent,
        ChangeMailComponent,
        ForgotPasswordComponent
    ],
    imports: [
        BrowserModule,
        RouterModule.forRoot(appRoutes),
        HttpModule,
        FormsModule
    ],
    providers: [
        AuthGuard,
        InitGuard,
        AccountService,
        AuthService,
        CategoryService,
        RecurrentService,
        SpinnerService,
        StmtService,
        TransferService,
    ],
    bootstrap: [AppComponent]
})

export class AppModule { }
